const container = {
  styleOverrides: {
    root: {
      maxWidth: '1162px !important'
    }
  }
};

export default container;
